import { initialState } from '..';
import { maxSelectionsInBetSlip } from '../config';
import type { BetSlipState, Selection } from '../types';

const selectionAdded = (state: BetSlipState, payload: Selection): BetSlipState => {
  if (state.isLocked || state.selections.length >= maxSelectionsInBetSlip) {
    return state;
  }

  const isSelected = state.selections.find(
    (selection) =>
      selection.selectionId === payload?.selectionId && selection.marketId === payload.marketId
  );

  if (isSelected) {
    return state;
  }

  return {
    ...state,
    receipt: initialState.receipt,
    selectedPromotionPicker: initialState.selectedPromotionPicker,
    selections: [...state.selections, payload]
  };
};

export default selectionAdded;
